import { CartItemVariant } from './CartItemVariant';

export const cartDrawerVariant: CartItemVariant = {
  imageSize: 'sm',
  textSize: 'sm',
  showQuantityBadge: false,
  showStrikethroughPrice: true,
  showQuantityText: false,
  priceMode: 'standard',
};

export const cartPageVariant: CartItemVariant = {
  imageSize: 'lg',
  textSize: 'lg',
  showQuantityBadge: false,
  showStrikethroughPrice: true,
  showQuantityText: false,
  priceMode: 'standard',
};

export const checkoutVariant: CartItemVariant = {
  imageSize: 'sm',
  textSize: 'sm',
  showQuantityBadge: true,
  showStrikethroughPrice: true,
  showQuantityText: false,
  priceMode: 'standard',
};

export const orderConfirmationVariant: CartItemVariant = {
  imageSize: 'sm',
  textSize: 'sm',
  showQuantityBadge: true,
  showStrikethroughPrice: true,
  showQuantityText: false,
  priceMode: 'adjusted',
};

export const orderDetailsVariant: CartItemVariant = {
  imageSize: 'responsive',
  textSize: 'md',
  showQuantityBadge: false,
  showStrikethroughPrice: true,
  showQuantityText: true,
  priceMode: 'final',
};
